export default "__VITE_ASSET__uFTZ7KBj__"